<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <reports-page />
    </div>
  </div>
</template>

<script>
import ReportsPage from '../Components/ReportsPage.vue';
export default {
  name: 'Reports',
  components: {
    'reports-page': ReportsPage,
  },
};
</script>
